import { Dispatch } from 'react-redux';
import { Action } from '../../../actions';
import ApiUtils from '../../../utils/api';
import DriveItemUtils from '../../../utils/driveItem';
import { StoreState } from '../../../reducers';
import Utils from '../../../utils';
import UserAgentUtils from '../../../utils/userAgent';
import { receiveResolutions, receiveDriveItems, getAllDriveItems } from '../actions';

export enum SearchDriveItemActionKeys {
	REQUEST_SEARCH = '@@searchDriveItem/REQUEST_SEARCH',
	RECEIVE_SEARCH = '@@searchDriveItem/RECEIVE_SEARCH',
	TOGGLE_SEARCH_FIELD_VISIBILITY = '@@searchDriveItem/TOGGLE_SEARCH_FIELD_VISIBILITY'
}

interface RequestSearchAction extends Action {
	type: SearchDriveItemActionKeys.REQUEST_SEARCH;
	searchString: string;
}

interface ReceiveSearchAction extends Action {
	type: SearchDriveItemActionKeys.RECEIVE_SEARCH;
	driveItemIds: number[];
}

interface ToggleSearchFieldVisibilityAction extends Action {
	type: SearchDriveItemActionKeys.TOGGLE_SEARCH_FIELD_VISIBILITY;
}

export type SearchDriveItemAction = RequestSearchAction
									| ReceiveSearchAction
									| ToggleSearchFieldVisibilityAction;

export const searchDriveItems = (searchString: string = '') =>
	(dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
		dispatch(requestSearch(searchString));

		const isMaster = Utils.isMaster(getState().galleryInfos.config);
		if (UserAgentUtils.isOnline() && !isMaster) {
			if (searchString) {
				ApiUtils.getSearch(searchString)
					.then(contentBlock => {
						const driveItemIds = Object.keys(contentBlock.metas).map(strindId => parseInt(strindId, 10));
						if (contentBlock.resolutions) {
							dispatch(receiveResolutions(contentBlock.resolutions));
						}
						dispatch(receiveDriveItems(contentBlock.metas));
						dispatch(receiveSearch(driveItemIds));
					});
			} else {
				if (UserAgentUtils.isMobileApp) {
					dispatch(getAllDriveItems())
						.then(driveItemIds => dispatch(receiveSearch(driveItemIds)));
				} else {
					dispatch(receiveSearch([]));
				}
			}
		} else {
			const { driveList } = getState();
			const { driveItems } = driveList;

			const driveItemsArray = Object.keys(driveItems).map(key => driveItems[parseInt(key, 10)]);
			const filteredArray = driveItemsArray.filter(driveItem => {
				if (driveItem.isInGallery === false) {
					return false;
				}

				if (searchString) {
					return DriveItemUtils.containsString(driveItem, searchString);
				}

				return true;
			});

			dispatch(receiveSearch(filteredArray.map(driveItem => driveItem.id)));
		}
};

const requestSearch = (searchString: string): RequestSearchAction => ({
	searchString,
	type: SearchDriveItemActionKeys.REQUEST_SEARCH
});

const receiveSearch = (driveItemIds: number[]): ReceiveSearchAction => ({
	type: SearchDriveItemActionKeys.RECEIVE_SEARCH,
	driveItemIds
});

export const toggleSearchFieldVisibility = (): ToggleSearchFieldVisibilityAction => ({
	type: SearchDriveItemActionKeys.TOGGLE_SEARCH_FIELD_VISIBILITY
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/Search/actions.ts